import * as Sentry from "@sentry/react";

// Only initialize Sentry in production or staging environments
const shouldInitializeSentry =
  import.meta.env.MODE === 'production' ||
  import.meta.env.MODE === 'staging';

if (shouldInitializeSentry) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    // Enable tracing for performance monitoring
    integrations: [
      Sentry.browserTracingIntegration()
    ],

    // Performance Monitoring
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 0.1,

    // Session Replay
    //replaysSessionSampleRate: 0.1, // 10% of sessions
    //replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors

    // Set environment
    environment: import.meta.env.MODE,

    // Disable debug logging to reduce console noise
    debug: false,

    // Filter out authentication-related errors (401, 403)
    beforeSend(event, hint) {
      // Check if the error is related to HTTP status codes
      const error = hint.originalException;

      // Check for axios/fetch errors with 401 or 403 status
      if (error && typeof error === 'object' && 'response' in error) {
        const response = error.response as { status?: number } | undefined;
        if (response?.status === 401 || response?.status === 403) {
          return null; // Don't send to Sentry
        }
      }

      // Check for status code in event contexts
      if (event.contexts?.response?.status_code === 401 ||
          event.contexts?.response?.status_code === 403) {
        return null; // Don't send to Sentry
      }

      return event;
    },

    // Ignore Sentry's own transport errors
    ignoreErrors: [
      'Encountered error running transport request',
      'Failed to fetch',
    ],
  });
}
